import Styled from './styled'

export default function Modal({ title, visible, children, onConfirm, footer, ...props }) {
  return (
    <Styled {...props} title={title} visible={visible} footer={footer}>
      {children}
    </Styled>
  )
}
